import type { HelpFile } from '../../types/help'
import { FieldPropertiesTestIds } from '../../../testids/FieldPropertiesTestIds'

export const fieldPropertiesHelp: HelpFile = {
  docPage: '/docs/admin/form-layouts',
  texts: {
    [FieldPropertiesTestIds.fieldLabelInput]:
      'Beschriftung über dem Feld im gerenderten Formular — leer lassen, um die Beschriftung der Attributdefinition zu verwenden.',
    [FieldPropertiesTestIds.fieldPlaceholderInput]:
      'Platzhaltertext im leeren Eingabefeld als Hinweis.',
    [FieldPropertiesTestIds.fieldDefaultInput]:
      'Vorausgefüllter Wert beim Anlegen eines neuen Datensatzes — leer lassen für keinen Standard.',
    [FieldPropertiesTestIds.fieldTemplateInput]:
      'Optionaler Template-Ausdruck zur Berechnung des Feldwerts (z. B. Verknüpfung anderer Felder).',
    [FieldPropertiesTestIds.colSpanCustomBtn]:
      'Spaltenbreitensteuerung in den benutzerdefinierten Modus wechseln, um einen beliebigen ganzzahligen Wert einzugeben.',
    [FieldPropertiesTestIds.colSpanCustomInput]:
      'Benutzerdefinierte Spaltenbreite (1–12) für dieses Feld — überschreibt die voreingestellten Schaltflächen.',
    [FieldPropertiesTestIds.visibilityFieldKeySelect]:
      'Feld wählen, dessen Wert die Sichtbarkeitsbedingung für das aktuelle Feld steuert.',
  },
}
